export const baseUrl = 'https://comunicaedu.com/'
